import graphql from 'graphql-tag'
import api from '@stores/apollo'

export default function update({ id, color }: { id: string; color: string }) {
  return api.gql.mutate({
    mutation,
    variables: {
      input: {
        where: { id },
        data: { color },
      },
    },
  })
}

const mutation = graphql`
  mutation UpdateDepartment($input: UpdateDepartmentInput!) {
    updateDepartment(input: $input) {
      department {
        id
      }
    }
  }
`
